module.exports = __webpack_public_path__ + "static/integration/img/ally-icon-indicator-high.739568badd8d10efc6b247bd28f610c8.svg";